import React from 'react';
import {GoogleMap, InfoWindow, Marker, withGoogleMap} from "react-google-maps";
import {
    AssignmentRuleMode,
    PayStatus,
    Permissions,
    RequestPaymentStatus,
    RequestStatus,
    TractorSuggestActions
} from "../../common/Constants";
import Utils, {getDefaultMapCenter} from "../../common/Utils";
import {
    Badge,
    Button,
    ButtonGroup,
    Form,
    FormGroup,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Popover,
    PopoverBody as PopoverContent,
    UncontrolledTooltip
} from "reactstrap";
import Spinner from 'react-spinkit';
import HtmlHelpers from "../../common/HtmlHelpers";
import HTML from "../../common/HtmlHelpers";
import AppGlobals from "../../common/AppGlobals";
import TTLProxy from "../../common/TTLAsyncProxy";
import './TractorRequestHandler.css';
import {MiscEndpoints, TractorRequestEndpoints, TractorsEndpoints} from "../../common/ProxyEndpoints";
import Icon from 'react-icons-kit';
import {ic_info} from 'react-icons-kit/md/ic_info';
import {renderStatus as StatusRender} from '../../views/Request/RequestCommon';
import HistoryLink from "../../common/HistoryLink";
import SmartDialog from "../SmartDialog/SmartDialog";
import MDProgress from 'react-md-progress-bar';
import TransactionCycleDialog from "../TransactionCycleDialog/TransactionCycleDialog";
import DialogCollapseSection from "../DialogCollapseSection/DialogCollapseSection";
import CheckInput from "../CheckInput/CheckInput";
import _ from 'lodash';
import TimeAgo from "../../common/TimeAgo";
import moment from 'moment';
import AppVariables from "../../common/AppVariables";
import CurrencyLabel from "../CurrencyLabel/CurrencyLabel";
import PropTypes from 'prop-types';
import NumberLabel from "../NumberLabel/NumberLabel";
import PermissionRender from "../PermissionRender/PermissionRender";
import {DefaultBindingProduct} from "../../views/Extras/Services/USSDServices/USSDServicesCommon";
import LocationSelectInput from "../LocationSelectInput/LocationSelectInput";
import DataList from "../TableListView/DataList";
import convert from 'convert-units';
import SuggestionDetailDialog from "./SuggestionDetailDialog";
import {ExpanderView, SectionedList} from "../AuditExplorer/Elements";
import StandardValue from "../../common/StandardValue";
import {css} from "glamor";
import ReactRating from "react-rating";
import LoadingOverlay from 'react-loading-overlay';
import {DAYS_OF_WEEK_LIST, MONTHS_LIST} from "../../data/calendar/calendar";
import EventListener from "../../common/EventListener";
import {getEventEmitter} from "../../common/Events/EventSource";
import LocationListener from "../../common/LocationListener";

const getDefaultCenter = getDefaultMapCenter;

const CONFIRM_BTN_COLOR = '#00b400';
const RULE_FAIL_COLOR = "#ff1300";
const RULE_PASS_COLOR = "#24d403";

//  The results per suggestions
const SuggestionTotalResults = [
    5,
   10,
   20,
   50,
   100,
   150,
   200,
   500,
   'Infinite'
];

const AssignmentTestParameter = {

    //  Failed USSD Service Rule
    USSDService: "0001",

    //  Failed Min Quantity Rule
    MinQuantity: "0002",

    //  Failed Max Quantity Rule
    MaxQuantity: "0003",

    //  Failed Province Filter
    Province: "0004",

    //  Failed District Filter
    District: "0005",

    //  Failed Ward Filter
    Ward: "0006",

    //  Failed Month Of Assignment
    Month: "0007",

    //  Failed Day of Assignment
    Day: "0008",

    //  Failed Start Hour of Assignment
    BeginHour: "0009",

    //  Failed End Hour of Assignment
    EndHour: "0010"

};

const Styles = {

    label: { },

    confirmBtn: {
        backgroundColor: CONFIRM_BTN_COLOR
    },

    coolBtn:{
        borderRadius: 5,
        padding: 8
    },

    activeMap:{
        borderRadius: "1px",
        borderColor: "#04af0b",
        padding: "0px",
        borderStyle: "solid",
        boxShadow: "0 0 33px #4caf50ba"
    },

    checkInput: {
        padding: 10,
        borderRadius: 2 ,
        marginBottom: 4
    }

};


const selectedSuggestionStyle = css({
   backgroundColor: 'rgb(0,0,0)',
   color: "white",
   '&:hover': {
       backgroundColor: 'rgb(64,64,64)'
   }
});

const tooltipClass = css({
   maxWidth: 280,
   width: 280
});


const formatRuleLabel = ({ rule , parameter },request) => {

    switch (parameter) {
        case AssignmentTestParameter.USSDService:
            return `${rule.service.name} service not supported`;
        case AssignmentTestParameter.MinQuantity:
            return `Min ${Utils.pluralize(rule.min_quantity,request.service.unit_name.toLowerCase())}: ${rule.min_quantity}`;
        case AssignmentTestParameter.MaxQuantity:
            return `Max ${Utils.pluralize(rule.max_quantity,request.service.unit_name.toLowerCase())}: ${rule.max_quantity} `;
        case AssignmentTestParameter.Province:
            return `Unavailable ${process.env.REACT_APP_LOCATION_COMP1}: ${request.province}`;
        case AssignmentTestParameter.District:
            return `Unavailable ${process.env.REACT_APP_LOCATION_COMP2}: ${request.district}`;
        case AssignmentTestParameter.Ward:
            return `Unavailable ${process.env.REACT_APP_LOCATION_COMP3}: ${request.ward}`;
        case AssignmentTestParameter.Day:
            return `Outside working days`;
        case AssignmentTestParameter.Month:
            return `Outside working month`;
        case AssignmentTestParameter.BeginHour:
            return `Before working hour`;
        case AssignmentTestParameter.EndHour:
            return `After working hour`;
    }

};

class ConfirmDialog extends React.Component {

    static propTypes = {
        title: PropTypes.any,
        message: PropTypes.any,
        confirmBtnColor: PropTypes.string,
        confirmBtnContent: PropTypes.any,
        onConfirmed: PropTypes.func
    };

    constructor(props){
        super(props);
        this.state = {
            isBusy: false
        };
    }

    show(){
        this._dlg.show();
    }

    onConfirm(){

        const props = this.props;
        if(props.onConfirmed){

            this.setState({
                isBusy: true
            });

            props.onConfirmed().then(success =>{

                //  close dialog
                this._dlg.toggle();

                //
                this.setState({
                    isBusy: false
                });

            });
        }
    }

    render(){
        const props = this.props;
        return <SmartDialog title={props.title} showCancelButton={false} ref={r => this._dlg= r }>
            {typeof props.message == "function" ? props.message() : props.message }
            <hr/>
            {this.state.isBusy && <MDProgress show={true} overlay={true}/>}
            <Button block={true} style={Styles.coolBtn} color={props.confirmBtnColor || "primary"} onClick={() => this.onConfirm() }>{props.confirmBtnContent}</Button>
        </SmartDialog>;
    }

}

/**
 * Renders google map
 */
const LoadMap = withGoogleMap( props => (
        <GoogleMap
            ref={props.onMapLoad}
            defaultZoom={props.defaultZoom}
            defaultCenter={ Utils.isValidLocation(props.center) ? props.center : getDefaultCenter()}
            onClick={props.onMapClick}
            onDrag={props.onDrag}
            onDragStart={props.onDragStart}
            defaultOptions={props.defaultOptions}
            onDragEnd={props.onDragEnd}
            onDblClick={props.onDoubleClick}
            onCenterChanged={props.onCenterChanged}>
            {props.markers.filter(i => Utils.isValidLocation(i.location)).map((item,id) =>{
                return (<Marker position={item.location}
                                title={item.title}
                                key={id}
                                onClick={item.onClick}
                                clickable={!!item.onClick}
                                options={{
                                    icon: props.icon
                                }}>
                        {item.title && <InfoWindow>
                            <div>
                                <h5>{item.title}</h5>
                            </div>
                        </InfoWindow>}
                </Marker>);
            })}

        </GoogleMap>
    )
);


const AssignmentMode = Object.freeze({
    None: "idle",
    PinLocation : "pin-location"
});


class LocationGuessDialog extends React.Component{

    static propTypes = {
        onSelect: PropTypes.func
    };

    constructor(props){
        super(props);
        this.state = this.getInitialState();
        this.proxy = TTLProxy.getInstance();
    }

    getInitialState(){

        return {
            guesses: [],
            place: "",
            isBusy: false
        };

    }

    show(place){

        //  reset state
        this.setState( this.getInitialState());

        //  load state
        this.loadState(place);

        this._dlg.show();

    }

    loadState(place){

        const proxy = this.proxy;

        this.setState({
            isBusy: true
        });

        return proxy.processRequest( MiscEndpoints.guessLocations(place) ).then(response => {

            this.setState({
                guesses: response.getPayload(),
                place: place,
                isBusy: false
            });

        }).catch(err => {

            //
            this.setState({
                isBusy: false
            });

        });
    }

    render(){

        const props = this.props;
        const guesses = this.state.guesses;
        return <LocationPicker ref={r => this._dlg = r} locations={guesses || [] } addressKey="address"  title={"Select Accurate Location"} onSelect={(location) => {

            if(props.onSelect){
                props.onSelect(location);
            }

        }}/>
    }
}

class AssignmentRuleInfoDialog extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            suggestionInfo: null,
            request: null,
            rules: [],
            filter: 'failed'
        };
    }

    runFilters(suggestionInfo,mode){

        switch (mode) {
            case 'none':
                return suggestionInfo.tractor.assignment_rules;
            case 'passed':
                return suggestionInfo.tractor.assignment_rules.filter(x => suggestionInfo.properties.passed_rules.find(t => x.id === t.rule.id));
            case 'failed':
                return suggestionInfo.tractor.assignment_rules.filter(x => suggestionInfo.properties.failed_rules.find(t => x.id === t.rule.id));
        }

    }

    show(suggestionInfo,request){

        this.setState({
            suggestionInfo ,
            request ,
            filter: 'failed' ,
            rules: this.runFilters(suggestionInfo,'failed')
        }, () => this._dlg.show());

    }

    render(){

        const { suggestionInfo , filter , rules } = this.state;
        const assignmentRules = rules || [];

        const setFilter = (filter) => {

            this.setState({
                filter,
                rules: this.runFilters(suggestionInfo,filter)
            }, () => this._list.refresh());

        };

        return <SmartDialog ref={r => this._dlg = r} title="Assignment Rules" large>

            <div className="clearfix">

                <div className="pull-right">

                    <ButtonGroup>
                        <Button active={filter === 'none'} onClick={() => setFilter('none')}>None</Button>
                        <Button active={filter === 'passed'} onClick={() => setFilter('passed')}>Passed <i className="fa fa-check" style={{ color: RULE_PASS_COLOR }}/></Button>
                        <Button active={filter === 'failed'} onClick={() => setFilter('failed')}>Failed <i className="fa fa-close" style={{ color: RULE_FAIL_COLOR }}/></Button>
                    </ButtonGroup>

                </div>

            </div>

            <DataList   responsive
                        hover={false}
                        listRef={r => this._list = r}
                        noRowsMessage="No rules defined yet"
                        columns={[
                        {
                            key: "service",
                            label: "Service",
                            render: item => {
                                return item.service.name;
                            }
                        },
                        {
                            key: "mode",
                            label: "Mode",
                            render: item => {

                                switch (item.mode) {
                                    case AssignmentRuleMode.Enabled:
                                        return "Enabled";
                                    case AssignmentRuleMode.Disabled:
                                        return "Disabled";
                                }
                            }
                        },
                        {
                            key: "status",
                            label: "Status",
                            render: item => {

                                const passedRules = this.state.suggestionInfo ? this.state.suggestionInfo.properties.passed_rules : null;
                                if(passedRules.find(x => x.rule.id === item.id))
                                    return <span style={{ color: RULE_PASS_COLOR }}>Passed <i className="fa fa-check"/></span>;

                                return <span style={{ color: RULE_FAIL_COLOR }}>Failed <i className="fa fa-close"/></span>
                            }
                        },
                        {
                            key: "parameter",
                            label: "Parameters (Failed)",
                            render: item => {

                                const failedRules = this.state.suggestionInfo ? this.state.suggestionInfo.properties.failed_rules : null;
                                const frame = failedRules.find(x => x.rule.id === item.id);
                                if(frame){

                                    const rule = frame.rule;
                                    const { request } = this.state;

                                    return <SectionedList defaultMode={"vertical"} items={frame.parameter.map(x => {

                                        let name;
                                        let expected;

                                        switch (x) {
                                            case AssignmentTestParameter.USSDService:
                                                name = "Service";
                                                break;
                                            case AssignmentTestParameter.MinQuantity:
                                                name = `Minimum Quantity`;
                                                expected =`${rule.min_quantity}  ${Utils.pluralize(rule.min_quantity, rule.service.unit_name.toLowerCase())}`;
                                                break;
                                            case AssignmentTestParameter.MaxQuantity:
                                                name = `Maximum Quantity`;
                                                expected = `${rule.max_quantity} ${Utils.pluralize(rule.max_quantity,rule.service.unit_name.toLowerCase())}`;
                                                break;
                                            case AssignmentTestParameter.Province:
                                                name = `${process.env.REACT_APP_LOCATION_COMP1} Availability`;
                                                expected = rule.locations.map(x => x.province).join(",");
                                                break;
                                            case AssignmentTestParameter.District:
                                                name = `${process.env.REACT_APP_LOCATION_COMP2} Availability`;
                                                expected = (() => {

                                                    let loc = rule.locations.find(x => x.province === request.province);
                                                    if(loc){
                                                        return loc.districts.map(x => x.district).join(",");
                                                    }

                                                    return '';
                                                })();
                                                break;
                                            case AssignmentTestParameter.Ward:
                                                name = `${process.env.REACT_APP_LOCATION_COMP3} Availability`;
                                                expected = (() => {

                                                    let loc = rule.locations.find(x => x.province === request.province);
                                                    if(loc){

                                                        const frame = loc.districts.find(x => x.district === request.district);
                                                        if(frame)
                                                            return frame.wards.join(",");

                                                    }

                                                    return '';

                                                })();
                                                break;
                                            case AssignmentTestParameter.Day:
                                                name = "Working Days";
                                                expected = `${rule.days_of_week.map(x => DAYS_OF_WEEK_LIST[Number(x) - 1].substr(0,3) ).join(", ")}`;
                                                break;
                                            case AssignmentTestParameter.Month:
                                                name = "Working Months";
                                                expected = `${rule.months_of_year.map(x => MONTHS_LIST[Number(x) - 1].substr(0,3) ).join(", ")}`;
                                                break;
                                            case AssignmentTestParameter.BeginHour:
                                                name = "Work Hour (Start)";
                                                expected = `${rule.active_hours.begin_hour}`;
                                                break;
                                            case AssignmentTestParameter.EndHour:{
                                                name = "Work Hour (End)";
                                                expected = `${rule.active_hours.end_hour}`;
                                            }break;
                                        }

                                        return  {
                                            title: <b style={{ fontSize: 'medium' }}>{name}</b>,
                                            value: <div className="mb-2">
                                                {formatRuleLabel({ rule , parameter: x },request)}
                                                {expected && <React.Fragment>
                                                    <hr className="m-0 mb-2"/>
                                                    <span><b style={{ color: "#404040" }}>Expectation:</b> {expected}</span>
                                                </React.Fragment>}
                                            </div>
                                        }

                                    })}/>



                                }


                            }
                        }
                    ]}
                    itemsPerPage={5}
                    data={assignmentRules}/>

        </SmartDialog>;

    }
}

class LocationPicker extends React.Component {

    static propTypes = {
        onSelect: PropTypes.func,
        locations : PropTypes.any,
        coords: PropTypes.object,
        noItemsMessage: PropTypes.string,
        addressKey: PropTypes.string,
        title: PropTypes.string
    };

    static defaultProps = {
        title: "Select Location",
        addressKey: "formatted_address"
    };

    constructor(props){
        super(props);
        this.state = {
            selectedIndex: null,
        };
    }

    show(){

        this.setState({
            selectedIndex: null
        });

        this._dlg.show();
    }

    render(){

        const props = this.props;
        const locations = this.props.locations || [];
        const noItems = locations.length === 0;

        return <SmartDialog title={props.title} ref={r => this._dlg = r} showCancelButton={noItems}>


                {noItems ? <p className="text-center">{props.noItemsMessage || "No places found matching coordinates"}</p> : <div style={{ marginBottom: 8 }}>
                    <p>Click to select the desired location</p>
                    {locations.map( (l,index) => {

                        const selected = this.state.selectedIndex == index;
                        const content =  <h6 style={{padding: 6 }}>{l[props.addressKey]}</h6>;
                        return <div key={index} style={ selected  ? { backgroundColor: "#e2e2e2" , cursor: "pointer" } : { cursor: "pointer" } } className="location-item" onClick={() =>{

                            this.setState({
                                selectedIndex: index
                            });

                        }}>
                            <div className="clearfix">
                                <div className="pull-left">
                                    {content}
                                </div>

                                {selected && <div className="pull-right">
                                    <i style={{ marginTop: 10 , marginRight: 15 , color: "green" }} className="fa fa-check"></i>
                                </div>}

                            </div>
                        </div>

                    })}</div>}
                <div className="clearfix">
                    <div className="pull-right">

                        {!noItems && <Button outline={true} color={"primary"}  onClick={() => {

                            if(this.props.onSelect){
                                this.props.onSelect(locations[this.state.selectedIndex]);
                            }

                            //  hide dialog
                            this._dlg.toggle();

                        }} style={{ borderRadius: 5 }} disabled={this.state.selectedIndex == null}><i className="fa fa-check"></i> Select Location</Button>}

                    </div>
                </div>
        </SmartDialog>
    }

}

class StatusCycleDialog extends React.Component{

    constructor(props){
        super(props);
        this.state = { };
    }

    show(request){

        this.setState({
            request: request
        });

    }

    render(){

        const request = this.state.request;
        if(!request){
            return null;
        }

        const cycles = request.status_cylcle;
        return <SmartDialog ref={r => this._dlg = r} title={"Request Status Cycle"} showCancelButton={false}>
            {cycles.map( (item,key) => {
                return <div style={{ padding: 10 }}>
                    <div>
                        <b>Status: </b> {item.status}
                    </div>
                    <hr/>
                    <p>{item.message}</p>
                    <div className="clearfix">
                        <div className="pull-right">
                            {moment(item.timestamp).format("ll")}
                        </div>
                    </div>
                </div>
            })}
        </SmartDialog>
    }

}

class TractorRequestHandler extends React.Component {

    static Events = [
        'tractor_request_assigned',
        'tractor_request_completed',
        'tractor_request_release',
        'tractor_request_location_change'
    ];

    geoCode;

    constructor(props){

        super(props);

        const frame = AppGlobals.get("settings");
        const assignmentOpts = frame["_request_assignment_opts"] || (function () {

            const defaultState = {
                maxResults: 5,
                useGPSState: true,
                withTrackersOnly: false,
                includeAssignedTractors: true,
                includeInactiveOwners: false
            };

            frame["_request_assignment_opts"]  = defaultState;
            AppGlobals.set("settings",frame);
            return defaultState;

        })();


        this.state = {
            isOpen: false,
            isBusy: false,
            overlayActive: false,
            overlayMessage: null,
            isSuggesting: false,
            suggestionCoord: null,
            request: null,
            requestOriginal: null,
            mapDefaultZoom: props.mapDefaultZoom,
            selectedPlace: null,
            suggestedTractors: null,
            assignmentMode: AssignmentMode.None,
            suggestionError: null,
            selectedSuggestion: null,
            trackCoord: null,

            //  Suggestion Options
            maxResults: assignmentOpts["maxResults"],
            useGPSState: assignmentOpts["useGPSState"],
            withTrackersOnly: assignmentOpts["withTrackersOnly"],
            includeAssignedTractors: assignmentOpts["includeAssignedTractors"],
            includeInactiveOwners: assignmentOpts["includeInactiveOwners"],

            enableRefund: false,
            refundAmount: 0,
            fullRefund: false,

            reverseGeoCodeResults: null,
            locationOverride: null,

            //  Show request assignment tip
            showAssignTip: null
        };

        try {
            this.geoCode = new window.google.maps.Geocoder;
        }
        catch(ex) {
            console.log("Failed loading geocode");
        }

        //  get proxy reference
        this.proxy = TTLProxy.getInstance();

        //  get global event dispatcher instance
        this.events = getEventEmitter();

        //
        this.onHandleTractorRequest = this.onHandleTractorRequest.bind(this);

        //  toggle
        this.toggle = this.toggle.bind(this);

        const me = this;

        //  declare columns for suggestion view
        this.suggestionColumns  = [
            {
                key: 'tractor' ,
                label: 'Tractor' ,
                render: item => {

                    const { tractor } = item;
                    const { operator } = tractor;
                    const id = `suggestion-row-tractor-${tractor.id}`;

                    return <React.Fragment>

                        <a href="#" id={id} style={{ color: "inherit" }} title="Click to see detailed info" onClick={evt => {

                            evt.preventDefault();
                            this._suggestionDetailDlg.show(item);

                        }}>{item.tractor.name}</a>

                        <UncontrolledTooltip target={id}
                                             placement={"bottom"}
                                             fade={false}>

                            <div className="text-left">
                                <p><b>Name: </b> {tractor.name}</p>
                                <p><b>Registration No: </b> {tractor.registration_number}</p>
                                <p><b>Model: </b> {tractor.tractor_model}</p>
                                <p><b>Year: </b> {tractor.year}</p>
                                <p><b>Chassis: </b> {tractor.chassis}</p>
                                <p><b>Operator: </b> {operator.name} ({operator.phone})</p>
                            </div>

                        </UncontrolledTooltip>

                    </React.Fragment>
                }
            },

            { key: 'owner' , label: 'Owner' , render: (item,key) => Utils.standardValue(item.tractor.owner.name) },
            //{ key: 'operator' , label: 'Operator' , cell: (item,key) => item.tractor.operator ? Utils.standardValue(item.tractor.operator.name) : "N/A" },

            {
                key: 'workload' ,
                label: 'Workload' ,
                render: item => {

                    const id = `suggestion-row-workload-${item.tractor.id}`;

                    return <React.Fragment>

                        <span id={id}><NumberLabel value={item.properties.totalRequests}/> assigned</span>

                        <UncontrolledTooltip target={id}
                                             placement={"bottom"}
                                             fade={false}>

                            <div className="text-left">
                                <p><b>Total Hectarage/Quantity: </b><NumberLabel value={item.properties.totalHectares}/></p>
                            </div>

                        </UncontrolledTooltip>

                    </React.Fragment>;
                },
            },
            //{ key: 'requests' , label: 'Assigned Request(s)' , cell: (item,key) =>  item.properties.totalRequests },
            {
                key: "offset" ,
                label: 'Distance' ,
                render: (item) => {
                    return <span><NumberLabel value={convert(item.properties.offset).from('m').to('km')}/> km</span>
                }
            },
            {
                key: "rules",
                label: 'Conditions',
                render: item => {

                    const { request } = me.state;
                    const id = `suggestion_rule_validity_tractor_${item.tractor.id}`;
                    const failedRules = item.properties.failed_rules;
                    const passedRules = item.properties.passed_rules;

                    return <span>
                        {failedRules.length > 0 ?
                            <React.Fragment>
                                <i id={id} className="fa fa-times-circle" style={{ color: RULE_FAIL_COLOR }} onClick={() => this._assignmentRuleDlg.show(item,request)}/>
                                <UncontrolledTooltip target={id}
                                                     placement={"bottom"}
                                                     innerClassName={`${tooltipClass} p-2`}
                                                     fade={false}>
                                    <div className="text-left p-1">
                                    <b style={{ color: RULE_FAIL_COLOR }}>Failed Params:</b> {_.sumBy(failedRules,x => x.parameter.length)}<br/>
                                    {failedRules.map((f,k) => {

                                        return <React.Fragment key={k}>
                                            {f.parameter.map((p,index) => (<div className="m-0" key={index}>
                                                <i className="fa fa-circle" style={{ fontSize: 10 }}/> {formatRuleLabel({ rule: f.rule, parameter: p },request)} <i className="fa fa-close" style={{ color: RULE_FAIL_COLOR }}/>
                                            </div>))}
                                        </React.Fragment>
                                    })}

                                    </div>
                                </UncontrolledTooltip>

                            </React.Fragment>
                             :
                            <React.Fragment>
                                <i id={id} className="fa fa-check-circle-o" style={{ color: RULE_PASS_COLOR  }}/>
                            </React.Fragment>

                        }
                    </span>
                }
            }
        ];
    }

    shouldComponentUpdate(){
        return this.state.request != null;
    }

    toggleOverlay(message,callback){

        this.setState(state => ({
            overlayActive: !state.overlayActive,
            overlayMessage: message
        }),callback);

    }

    toggle(){

        this.setState({
            isOpen: !this.state.isOpen
        });

    }

    static getSession(key,defValue){

        const v = window.sessionStorage.getItem(key);
        if(v === undefined && defValue !== undefined){
            window.sessionStorage.setItem(key,defValue);
        }

        return v === undefined ? defValue : v;
    }

    handleRequest(request){

        if(!request)
            return;

        //  Set initial state
        this.setState({

            //  This can be modified
            request: _.cloneDeep(request),

            //  Never modified
            requestOriginal: _.cloneDeep(request),

            selectedPlace: null,
            suggestedTractors: null,
            selectedTractor: null,
            selectedSuggestion: null,
            trackCoord: null,
            reverseGeoCodeResults: null,
            locationOverride:null,
            isOpen: true,
            assignmentMode: AssignmentMode.None,
            showAssignTip: false,
            settingsDirty: false,
        });

        //
        const coord = { lat: request.location_lat , lng: request.location_long };
        if(Utils.isValidLocation(coord) && (request.status == RequestStatus.Unassigned))
            window.setTimeout(() => this.suggestTractors(coord.lat,coord.lng) , 475);

    }


    onCompleteTractorRequest(request,comments){

        const events = this.events;
        const props = this.props;

        return this.proxy.processRequest(TractorRequestEndpoints.completeRequest(request.id,comments || null)).then(response => {

            if(response.ok) {

                //
                if(props.onRequestComplete){
                    props.onRequestComplete(request);
                }

                //  emit
                events.emit('tractor_request_complete',request);
                events.emit('on_request_update', request.id);

                console.log(`Request ${request.order_id} completed successfully!`);

                return true;
            }

        }).catch(err => {
            HtmlHelpers.toastWarning(Utils.getResponseError(err));
        });
    }

    onReleaseTractor(request,comments){

        const events = this.events;
        const props = this.props;
        const state = this.state;

        const releaseOptions = {
            refund: state.enableRefund,
            refundAmount: state.enableRefund ?  state.refundAmount : undefined,
            fullRefund: state.enableRefund ?  state.fullRefund : undefined,
            comments: comments || null
        };

        return this.proxy.processRequest(TractorRequestEndpoints.releaseRequest(request.id,releaseOptions)).then(response => {

            if(response.ok) {

                //
                if(props.onRequestReleased){
                    props.onRequestReleased(request);
                }

                //  emit
                events.emit('tractor_request_release',request);
                events.emit('on_request_update', request.id);

                console.log(`Request ${request.order_id} released successfully!`);

                return true;
            }

        }).catch(err => {

            //
            HtmlHelpers.toastWarning(Utils.getResponseError(err));

        });

    }

    onAssignRequest(request , tractor , location , comments ){

        const events = this.events;
        const props = this.props;

        const options = TractorRequestEndpoints.assignTractorRequest(request.id,tractor.id,location,comments || null);
        return this.proxy.processRequest(options).then(response => {

            if(response.ok) {

                const args = {
                    request: request,
                    tractor: tractor,
                    location: location
                };

                if(props.onRequestAssigned){
                    props.onRequestAssigned(args);
                }

                events.emit('tractor_request_assigned',args);
                events.emit('on_request_update', request.id);

                console.log(`Request ${request.order_id} assigned to tractor successfully!`);
                return true;
            }

        }).catch(err => {
            HtmlHelpers.toastWarning(Utils.getResponseError(err));
        });

    }


    onChangeRequestLocation(request , location){

        const events = this.events;
        const props = this.props;

        return this.proxy.processRequest(TractorRequestEndpoints.update(request.id,{
            location: location.text,
            location_lat: location.lat,
            location_long: location.lng
        })).then(response => {

            if(response.ok){

                const args = {
                    request: request,
                    location: location
                };

                if(props.onLocationChanged){
                    props.onLocationChanged(args);
                }

                events.emit('tractor_request_location_change',args);
                events.emit('on_request_update', request.id);

                console.log('Request location changed successfully!');

                return true;
            }

        }).catch(err =>{

            //
            HtmlHelpers.toastWarning(Utils.getResponseError(err));

        });

    }

    beginReleaseRequest(request){

        this.setState({
            enableRefund: false,
            refundAmount: request.cost,
            fullRefund: false
        });

        this._confirmReleaseDlg.show();
    }

    _isConfirmed(req){
        return req;
    }

    renderReleaseDlg(request) {

        return <ConfirmDialog ref={r => this._confirmReleaseDlg = r}
                       message={<div>
                           <div>Please confirm tractor request cancellation?</div>
                           <div><b>Note:</b> This operation is irreversible. Please proceed with caution</div>

                           {(request.payment_status.status === PayStatus.PaidPartially || request.payment_status.status === PayStatus.PaidFully) && <div className="mt-2">
                               <DialogCollapseSection title={<b>Refund Information</b>} initiallyOpen={false}>

                                   <hr/>

                                   <div style={{padding: 5}}>

                                       <div>

                                           <p><input type="checkbox"  checked={this.state.enableRefund} onChange={evt => {

                                               this.setState({
                                                   enableRefund: evt.target.checked
                                               });

                                           }} /> Enable Refund</p>

                                       </div>

                                       <input type="number"
                                              disabled={!this.state.enableRefund || this.state.fullRefund}
                                              value={this.state.fullRefund ? request.cost : this.state.refundAmount}
                                              className="form-control"
                                              placeholder="Enter total amount to refund"
                                              onChange={evt =>{

                                                  const value = evt.target.value;

                                                  this.setState({
                                                      refundAmount: value === "" ? 1  : Math.min( Number(value) , request.cost )
                                                  });

                                              }}/>

                                       <div className="clearfix">
                                           <div className="pull-right">
                                               <p>Full Refund <input disabled={!this.state.enableRefund} type="checkbox" checked={this.state.fullRefund} onChange={evt => {

                                                   this.setState({
                                                       fullRefund: evt.target.checked,
                                                   });

                                               }} /> </p>
                                           </div>
                                       </div>

                                   </div>

                               </DialogCollapseSection>
                           </div>}


                           <hr/>
                           <b><i className="fa fa-comment"/> Reason/Comment</b>
                           <textarea placeholder={"Enter reason or comments for cancelling request here..."}
                                     ref={r => this._comments = r}
                                     className="form-control form-input-select"
                                     rows={3}/>

                       </div>}
                       title={"Cancel/Release Request"}
                       confirmBtnColor="danger"
                       confirmBtnContent={<span><i className="fa fa-remove"/> Release Request</span>}
                       onConfirmed={() => this.onReleaseTractor(request,this._comments.value).then((success) => {

                           //  close parent dialog
                           if(success){
                               HTML.toastSuccess("Request cancelled successfully");
                               this.toggle();
                           }

                       })}/>
    }

    renderFooter(){

        const me = this;
        const state=  this.state;
        const request = this.state.request;
        const isSuggesting = this.state.isSuggesting;

        switch (request.status){
            case RequestStatus.Completed:
                return null;
            case RequestStatus.Assigned:
                return (<ModalFooter>

                        <div style={{width: '100%' , height: '100%'}} className="row">

                            <PermissionRender required={[Permissions.Requests.Cancel]}>

                                <div className="col-md-6">
                                    <Button block={true} disabled={isSuggesting} onClick={() => this.beginReleaseRequest(request) } color="danger"><i className="fa fa-remove"></i> Release Request</Button>
                                </div>

                            </PermissionRender>

                            <PermissionRender required={[ Permissions.Requests.Complete ]}>

                                <div className="col-md-6">
                                    <Button block={true} disabled={isSuggesting} onClick={() => this._confirmCompleteDlg.show()} color={"primary"} outline={true} ><i className="fa fa-check"></i>  Complete Tractor Request</Button>
                                </div>

                            </PermissionRender>


                            {/*<div className="col-md-6">
                                <ConfirmButton
                                    color="danger"
                                    confirmBtnStyle={Styles.confirmBtn}
                                    icon="icon-trash"
                                    text="Delete"
                                    confirmTitle="Delete Request"
                                    confirmMessage="Are you sure you to delete request. NOTE: The operation is irreversible!"
                                    confirmText="Delete"
                                    onConfirmed={() => {

                                        console.log('Confirmed');
                                        this.onDeleteRequest(request).then(() => {

                                            this.toggle();

                                        });

                                    }}
                                />
                            </div>*/}

                        </div>

                    {this.renderReleaseDlg(request)}

                    <ConfirmDialog ref={r => this._confirmCompleteDlg = r}
                                   message={() => {
                                       return (request) && <div>
                                           <div>You are about to complete the tractor request by <b>{request.name}</b></div>
                                           <div><b>Note:</b> This operation is irreversible. Please proceed with caution</div>

                                           <div className="mt-2" style={{backgroundColor: "#ececec", padding: 10 }}>

                                               <ExpanderView title={"Request Details"} isExpanded>

                                                   <SectionedList items={[
                                                       {
                                                           title: "ID",
                                                           value: request.order_id
                                                       },
                                                       {
                                                           title: "Time Sent",
                                                           value: Utils.formatDateStandard(request.date_created)
                                                       },
                                                       {
                                                           title: "Assignment Time",
                                                           value: Utils.formatDateStandard(request.date_assigned)
                                                       },
                                                       {
                                                           title: "Time Began",
                                                           value: <StandardValue value={request.date_started || request.date_assigned}>
                                                               {Utils.formatDateStandard(request.date_started || request.date_assigned)}
                                                           </StandardValue>
                                                       },
                                                       {
                                                           title: "Estimated Duration",
                                                           value: Utils.formatDuration(request.date_started || request.date_assigned , new Date())
                                                       }
                                                   ]}/>

                                               </ExpanderView>

                                               <hr/>

                                               {request.tractor && <ExpanderView title={"Tractor Details"} isExpanded={false}>

                                                   <SectionedList items={[
                                                       {
                                                           title: "Name",
                                                           value: request.tractor.name
                                                       },
                                                       {
                                                           title: "Registration Number",
                                                           value: request.tractor.registration_number
                                                       },
                                                       {
                                                           title: "Chassis",
                                                           value: request.tractor.chassis
                                                       },
                                                       {
                                                           title: "Model",
                                                           value: request.tractor.tractor_model
                                                       }
                                                   ]}/>

                                               </ExpanderView>}

                                               <hr/>

                                               {request.tractor_operator && <ExpanderView title={"Driver/Operator Info"} isExpanded={false}>

                                                   <SectionedList items={[
                                                       {
                                                           title: "Name",
                                                           value: request.tractor_operator.name
                                                       },
                                                       {
                                                           title: "Phone",
                                                           value: request.tractor_operator.phone
                                                       },
                                                       {
                                                           title: "License Class(es)",
                                                           value: request.tractor_operator.license
                                                       }
                                                   ]}/>

                                               </ExpanderView>}

                                           </div>


                                           <hr/>

                                           <b><i className="fa fa-comment"/> Reason/Comment</b>
                                           <textarea placeholder={"Enter reason or comments for completing request here..."}
                                                     ref={r => this._comments = r}
                                                     className="form-control form-input-select"
                                                     rows={3}/>

                                       </div>
                                   }}
                                   title={"Complete Tractor Request"}
                                   confirmBtnColor="green"
                                   confirmBtnContent={<span><i className="fa fa-check"/> Complete Request</span>}
                                   onConfirmed={() => this.onCompleteTractorRequest(request,this._comments.value).then((success) =>{

                                       if(success){
                                           HTML.toastSuccess("Request completed successfully");
                                           this.toggle();
                                       }


                                   })}/>

                </ModalFooter>);

            case RequestStatus.Unassigned:

                const selectedSuggestion  = this.state.selectedSuggestion;
                const visibleLocation = this.state.locationOverride || this.state.selectedPlace;
                const allowAssign =   selectedSuggestion;
                const allowChangeLocation  = this.state.selectedPlace != null;
                const tractor = selectedSuggestion ? selectedSuggestion.tractor : null;
                const placeInput = this._placeInput;

                return (<ModalFooter>

                    <SmartDialog ref={r => this._settingsDlg = r} title={"Assignment Options"} showCancelButton={true} onExit={() =>{

                        if(this.state.settingsDirty){

                            this.setState({
                               settingsDirty: false
                            });

                            this.refreshSuggestion();
                        }

                    }}>

                        <div style={{ maxHeight: 320 ,overflowY: "auto" }}>

                            <CheckInput title="Use GPS State"
                                        style={Styles.checkInput}
                                        hint="This option controls whether to use the coordinates captured from the GPS devices attached to the tractors for refining the results"
                                        onChange={(evt) =>{
                                            this.updateSetting("useGPSState",evt.target.checked);
                                        }}
                                        checked={state.useGPSState}/>

                            <CheckInput title="Only Tracked"
                                        style={Styles.checkInput}
                                        hint="Controls whether to suggest tractors with tracking devices attached"
                                        onChange={(evt) => {
                                            this.updateSetting("withTrackersOnly",evt.target.checked);
                                        }}
                                        checked={state.withTrackersOnly}/>

                            <CheckInput title="Include Assigned Tractors"
                                        style={Styles.checkInput}
                                        hint="Determines whether suggestion results will include assigned tractors as well"
                                        onChange={(evt) =>{
                                            this.updateSetting("includeAssignedTractors",evt.target.checked);
                                        }}
                                        checked={state.includeAssignedTractors}/>

                            <CheckInput title="Include Inactive Owner Tractors"
                                        style={Styles.checkInput}
                                        hint="Controls whether to include suggestion for tractors whose owner's account are deactivated, inactive or locked. This option is strictly not recommended."
                                        onChange={(evt) =>{
                                            this.updateSetting("includeInactiveOwners",evt.target.checked);
                                        }}
                                        checked={state.includeInactiveOwners}/>

                        </div>

                    </SmartDialog>

                    {this.renderReleaseDlg(request)}

                    <div className="row" style={{width: '100%' , height: '100%'}}>

                        <PermissionRender required={[ Permissions.Requests.Assign ]}>
                            <div className="col-md-4">
                                <Button block={true} disabled={!allowAssign || isSuggesting} onClick={() => this._confirmAssignDlg.show() } style={{ borderRadius: 2 }} color="green"><i className="fa fa-bolt"></i> Assign Request</Button>
                            </div>
                        </PermissionRender>

                        <PermissionRender required={[ Permissions.Requests.Update ]}>
                            <div className="col-md-3">
                                <Button block={true} disabled={!this.state.selectedPlace || isSuggesting} onClick={() => this._confirmChangeLocationDlg.show() } style={{ borderRadius: 2 }} outline={true} color="primary"><i className="fa fa-map-marker"></i> Change Location</Button>
                            </div>
                        </PermissionRender>

                        <PermissionRender required={[ Permissions.Requests.Cancel ]}>
                            <div className="col-md-3">
                                <Button block={true} outline={true} color={"danger"} onClick={() => this.beginReleaseRequest(request) }><i className="fa fa-remove"></i> Release Request</Button>
                            </div>
                        </PermissionRender>

                        <PermissionRender required={[ Permissions.Requests.Assign ]}>
                            <div className="col-md-2">

                                <Button block={true} disabled={isSuggesting} color={"primary"} outline={true} style={{ borderRadius: 2 }} onClick={() =>{

                                    this.setState({
                                        settingsDirty: false
                                    });

                                    this._settingsDlg.show();

                                }}><i className="fa fa-gear"/></Button>

                            </div>
                        </PermissionRender>

                        {/*<div className="col-md-4">
                            <ConfirmButton
                                color="danger"
                                confirmBtnStyle={Styles.confirmBtn}
                                icon="icon-trash"
                                text="Delete"
                                confirmTitle="Delete Request"
                                confirmMessage="Are you sure you to delete request. NOTE: The operation is irreversible!"
                                confirmText="Delete"
                                onConfirmed={() => {

                                    this.onDeleteRequest(request).then(() => {
                                        this.toggle();
                                    });

                                }}
                            />
                        </div>*/}

                    </div>

                    <ConfirmDialog ref={r => this._confirmAssignDlg = r}
                                   confirmBtnColor={"green"}
                                   message={() => this.state.selectedSuggestion &&
                        <div>
                            <p>Please confirm request assignment?</p>

                            <div style={{backgroundColor: "#ececec", padding: 10 }}>
                                <DialogCollapseSection title={"Assignment Details"} initiallyOpen={true}>

                                    <dl>

                                        <dt>Request ID</dt>
                                        <dd>{request.order_id}</dd>

                                        <dt>Tractor</dt>
                                        <dd>{tractor.name} ({tractor.registration_number})</dd>

                                        <dt>Owner</dt>
                                        <dd>{tractor.owner ? tractor.owner.name : "N/A"}</dd>

                                        <dt>Driver/Operator</dt>
                                        <dd>{tractor.operator ? `${tractor.operator.name} (${tractor.operator.phone})` : "N/A"}</dd>

                                    </dl>
                                </DialogCollapseSection>
                            </div>

                            <hr/>

                            <b><i className="fa fa-comment"/> Reason/Comment</b>
                            <textarea placeholder={"Enter reason or comments for assigning request here..."}
                                      ref={r => this._comments = r}
                                      className="form-control form-input-select"
                                      rows={3}/>


                        </div>} title={"Assign request"} confirmBtnContent={<span><i className="fa fa-bolt"/> Assign Request</span>} onConfirmed={() =>{

                            const actualPlace = placeInput.getPlaceFull();
                            return this.onAssignRequest(request, me.state.selectedSuggestion.tractor  ,
                                Utils.isValidLocation(actualPlace) ? actualPlace : undefined ,
                                 this._comments.value
                                ).then((success) => {

                                    if(success){
                                        HTML.toastSuccess("Request assigned successfully");
                                        this.toggle();
                                    }

                            });
                    }}/>

                    <ConfirmDialog ref={r => this._confirmChangeLocationDlg = r} message={() => (this.state.selectedPlace && !isSuggesting) &&
                                    <p>Confirm location change from <b>{request.location}</b> to <b>{placeInput ? placeInput.getPlaceFull().text : ""}</b>?</p>}
                                   title={"Confirm Location Change"}
                                   confirmBtnColor="green"
                                   confirmBtnContent={<span><i className="fa fa-map-marker"/> Change Location</span>}
                                   onConfirmed={() => {

                                    return this.onChangeRequestLocation(request,placeInput.getPlaceFull()).then((success) => {

                                        if(success){

                                            const location = placeInput.getPlaceFull();

                                            //  update location
                                            request.location = location.text;
                                            request.location_lat = location.lat;
                                            request.location_long = location.lng;

                                            this.setState({
                                                request: request
                                            });

                                        }


                                    });

                    }}/>

                </ModalFooter>);
        }

        return null;
    }

    refreshSuggestion(){

        const state = this.state;
        const coord = state.suggestionCoord;
        if(coord){
            this.suggestTractors(coord.lat,coord.lng);
        }

    }

    /**
     * Suggest tractor for the given coordinates
     * @param lat
     * @param lng
     */
    suggestTractors(lat,lng){

        const me = this;

        const state = this.state;

        this.setState({
            isSuggesting: true,
            suggestionCoord: {
                lat: lat,
                lng: lng
            }
        });

        //  suggestion options
        const options = {
            action: TractorSuggestActions.Assignment,
            center: {
                lat: lat,
                lng: lng
            },
            allowInactiveOwners: state.includeInactiveOwners,
            useGPS: state.useGPSState,
            includeAssignedTractors: state.includeAssignedTractors,
            hasTrackerOnly: state.withTrackersOnly,
            maxResults: state.maxResults === 'Infinite' ? undefined : state.maxResults,
            request_id: state.request.id
        };

        return this.proxy.processRequest(TractorsEndpoints.suggestTractors(options)).then(response => {

            const predictions = response.getPayload();

            me.setState({
                isSuggesting: false,
                suggestedTractors: predictions,
                settingsDirty: false
            });

        }).catch((err) => {

            //
            me.setState({
                isSuggesting: false,
                suggestionError: Utils.getResponseError(err),
                settingsDirty: false
            });

        });

    }


    //  ----------------------------
    //  Event Listeners
    //  ----------------------------

    async queryRequest(id){

        try{

            const response = await this.proxy.processRequest( TractorRequestEndpoints.get(id).url , {
                include: [
                    'tractor' ,
                    'tractor_operator' ,
                    'owner' ,
                    'fbo',
                    'farmer',
                    'transactions' ,
                    'service',
                    'binder' ,
                    'payment_status',
                    'payments_issued',
                    'status_cycle',
                    'price_binding'
                ]
            });

            return response.getPayload();
        }
        catch (e) {
            HTML.toastWarning(Utils.getResponseError(e));
        }

        return null;
    }

    /**
     *
     * Show tractor request dialog
     * @param request
     */
    onHandleTractorRequest(request){

        this.setState({
            isOpen: true
        }, async () => {

            if(typeof request === "number"){

                this.toggleOverlay("Fetching request info. Please hold on...");

                try{

                    const payload = await this.queryRequest(request);
                    if(payload){
                        this.handleRequest(payload);
                    }
                }
                finally {
                    this.toggleOverlay(null);
                }

            }
            else{

                this.handleRequest(request);
            }
        });

    }

    //  ----------------------------

    updateSetting(key,value, refreshSuggestion = false){

        //
        const frame = AppGlobals.get("settings");
        frame._request_assignment_opts[key] = value;
        AppGlobals.set("settings",frame);

        //
        this.setState({
            [key] : value,
            settingsDirty: true
        });

        if(refreshSuggestion)
            this.refreshSuggestion();
    }

    onEventHandler(key,data){

        switch (key) {

            case 'handle_tractor_request':
                this.onHandleTractorRequest(data);
                break;

                //  TODO: Other events here
        }
    }

    renderPostContent(){

        const me = this;
        const state = this.state;
        const request = state.request;

        let postContent;
        switch (request.status){
            case RequestStatus.Cancelled:{
                postContent = <div>
                    <div className="panel">

                        <div className="panel-heading">
                            <h5>Assignment Details</h5>
                        </div>

                        <div className="row mb-1">
                            <div className="col-md-4">
                                <b><i className="fa fa-calendar"></i> Time Assigned</b>
                                <p>{request.date_assigned ? Utils.formatDateStandard(request.date_assigned) : "NOT ASSIGNED" }</p>
                            </div>
                            <div className="col-md-4">
                                <b><i className="fa fa-user"></i> Operator</b>
                                <p>{request.tractor_operator ? <HistoryLink url={`/operators?filter_id=${request.tractor_operator.id}&q=${request.tractor_operator.name}`}>{request.tractor_operator.name }</HistoryLink> : "NOT ASSIGNED"}</p>
                            </div>
                            <div className="col-md-4">
                                <b>{HTML.renderIcon("tractor")} Tractor</b>
                                <p>{request.tractor ? <HistoryLink url={`/tractors?filter_id=${request.tractor.id}&q=${request.tractor.name}`}>{Utils.formatTractorName(request.tractor,false,false)}</HistoryLink> : "NOT ASSIGNED"}</p>
                            </div>

                        </div>
                    </div>
                    <hr/>
                    <div style={{ backgroundColor:"#f3f3f3" , padding: 20 }}>
                        <b>Cancelled By: </b>  {request.binder ? request.binder.name : (request.farmer ? request.farmer.name : <Badge pill>Unknown</Badge>)}
                    </div>
                </div>
            }break;
            case RequestStatus.Unassigned:
                postContent = (<PermissionRender required={[Permissions.Requests.Assign]}>
                    <div>
                        <hr />
                        <div>

                            <div className="clearfix">

                                <h5 className="pull-left">Assign Request</h5>

                                <div className="pull-right">

                                    <label>

                                        Maximum Results: <select className="form-input" style={{ marginRight: 5 , padding: 2 }} value={state.maxResults} onChange={(evt) =>{

                                        this.updateSetting("maxResults",evt.target.value, true );

                                    }}>
                                        {SuggestionTotalResults.map((x,i) => {
                                            return <option key={i} value={x}>{x}</option>
                                        })}

                                    </select>
                                    </label>

                                    <span id="tipToggle" onClick={() => this.setState({ showAssignTip: true })}>
                                    <Icon icon={ic_info}/>
                                </span>



                                </div>

                                <Popover placement={"top"} isOpen={this.state.showAssignTip}  target={"tipToggle"} toggle={() => {

                                    this.setState({
                                        showAssignTip: !this.state.showAssignTip
                                    });

                                }}>
                                    <PopoverContent className="p-3">
                                        <h6>How to assign a request</h6>
                                        <p>To assign the request, enter the appropriate/correct <b>location</b> below and select it from the dropdown menu. A list of finely distributed tractors will be listed. Finally, select the best matching <b>tractor</b> for the request from the list</p>
                                    </PopoverContent>
                                </Popover>

                                <LocationGuessDialog ref={r => this._locationGuessDlg = r} />

                                <LocationPicker ref={r => this._locationPicker = r} coords={this.state.trackCoord} locations={this.state.reverseGeoCodeResults} onSelect={e =>{

                                    const result = e;
                                    const lat =  result.geometry.location.lat();
                                    const lng = result.geometry.location.lng();

                                    //
                                    this._placeInput.setLocation( result.formatted_address,lat,lng);

                                    //
                                    this.setState({
                                        assignmentMode: AssignmentMode.None,
                                        locationOverride:{
                                            location: result.formatted_address,
                                            lat: lat,
                                            lng: lng
                                        }
                                    });

                                    //
                                    this.suggestTractors(lat,lng);

                                    //  move map to targeted location
                                    this._mapView.panTo({ lat : lat , lng : lng });

                                }}/>

                            </div>

                            {this.state.isBusy ? <Spinner name="double-bounce" className="pull-right"/> : null }
                        </div>

                        <PermissionRender optional={[ Permissions.Requests.Assign , Permissions.Requests.Update ]}>

                            <Form onSubmit={evt => evt.preventDefault()}>
                                <FormGroup>
                                    <LocationSelectInput
                                        ref={(input) => this._placeInput = input}
                                        className="form-control form-input-select"
                                        placeholder="Enter location to assign here..."
                                        style={{width: '100%'}}
                                        onChange={(e) => {

                                            //
                                            let v = e.target.value.toString();
                                            if(v.length === 0){

                                                this.setState({
                                                    selectedPlace: null,
                                                    selectedSuggestion: null,
                                                    suggestedTractors: null
                                                });

                                            }

                                        }}
                                        onPlaceSelected={(place) => {

                                            let lat = place.geometry.location.lat();
                                            let lng = place.geometry.location.lng();

                                            //
                                            if(lat == request.location_lat && lng == request.location_long ) {
                                                return;
                                            }

                                            //  perform tractor suggestions
                                            this.suggestTractors(lat,lng);

                                            //  keep reference of selected place
                                            this.setState({
                                                selectedPlace: place,

                                                //  clear location override
                                                locationOverride: null,

                                                //  remove assignment mode
                                                assignmentMode: AssignmentMode.None
                                            });

                                            //  move map to targeted location
                                            this._mapView.panTo({ lat : lat , lng : lng });

                                        }}
                                        types={['(regions)']}
                                        componentRestrictions={{country: AppVariables.PlacesAutoCompleteCountry }}
                                    />
                                </FormGroup>
                            </Form>

                        </PermissionRender>

                        <div style={/*(this.state.suggestedTractors) ? { minHeight: '380px' } : null*/ {}}>

                            {this.state.isSuggesting && <div className="text-center">
                                <Spinner name="ball-pulse-sync"/>
                                <p>Suggestion in progress, please hold on...</p>
                            </div>}

                            {this.state.suggestedTractors && !this.state.isSuggesting &&
                            <div>


                                {this.state.suggestedTractors.length === 0 ? <div className="text-center">
                                    <p>No tractors available for the current suggestion. Try changing the options to see</p>
                                </div> :  <React.Fragment>

                                    <AssignmentRuleInfoDialog ref={r => this._assignmentRuleDlg = r}/>

                                    <DataList listRef={r => this._suggestionList = r}
                                              columns={this.suggestionColumns}
                                              data={this.state.suggestedTractors}
                                              itemsPerPage={5}
                                              hover={false}
                                              noRowsMessage="No tractors available for assignment (:-"
                                              defaultRowClass={"select-item"}
                                              getRowClass={item => {
                                                  return item === this.state.selectedSuggestion ? `${selectedSuggestionStyle}`: "";
                                              }}
                                              onRowClick={item => {

                                                  //
                                                  if(this.state.selectedSuggestion === item){

                                                      this.setState({
                                                          selectedSuggestion: null
                                                      });

                                                  }
                                                  else {

                                                      this.setState({
                                                          selectedSuggestion: item
                                                      });

                                                  }

                                              }}
                                              responsive />
                                </React.Fragment>}

                            </div>}

                        </div>

                    </div>
                </PermissionRender>);
                break;
            case RequestStatus.Completed:
                postContent = (<div>
                    <hr/>
                    <div className="panel">

                        <div className="panel-heading">
                            <h5>Assignment Details</h5>
                        </div>

                        <div className="row mb-1">
                            <div className="col-md-4">
                                <b><i className="fa fa-calendar"></i> Time Assigned</b>
                                <p>{request.date_assigned ? Utils.formatDateStandard(request.date_assigned) : "N/A" }</p>
                            </div>
                            <div className="col-md-4">
                                <b><i className="fa fa-user"></i> Operator</b>
                                <p>{request.tractor_operator ? <HistoryLink url={`/operators?filter_id=${request.tractor_operator.id}&q=${request.tractor_operator.name}`} onClick={this.toggle.bind(this)}>{request.tractor_operator.name }</HistoryLink> : "N/A"}</p>
                            </div>
                            <div className="col-md-4">
                                <b>{HTML.renderIcon("tractor")} Tractor</b>
                                <p>{request.tractor ? <HistoryLink url={`/tractors?filter_id=${request.tractor.id}&q=${request.tractor.name}`} onClick={this.toggle.bind(this)}>{Utils.formatTractorName(request.tractor,false,false)}</HistoryLink> : "N/A"}</p>
                            </div>


                        </div>

                        <div style={{ backgroundColor:"#f3f3f3" , padding: 20 }} className="row">
                            <div className="col-md-4">
                                <b>Assigned By: </b>  {request.binder ? request.binder.name : <h6><Badge pill={true}>Unknown</Badge></h6>}
                            </div>
                            <div className="col-md-4">
                                <b>Time Completed: </b> <TimeAgo style={{display: "inline"}} date={request.date_completed} id={`time_completed_${request.id}`}/>
                            </div>
                            <div className="col-md-4">
                                <b>Duration:</b> {(request.date_assigned && request.date_completed) ?  Utils.formatDuration(request.date_assigned,request.date_completed) : "N/A"}
                            </div>
                        </div>



                    </div>
                </div>);
                break;
            case RequestStatus.Assigned:
                postContent = (<div>
                    <hr/>
                    <div className="panel">
                        <div className="panel-heading">
                            <h5>Assignment Details</h5>
                        </div>
                        <div className="row">
                            <div className="col-md-4">
                                <b><i className="fa fa-calendar"></i> Time Assigned</b>
                                <p>{request.date_assigned ? Utils.formatDateStandard(request.date_assigned) : "N/A" }</p>
                            </div>
                            <div className="col-md-4">
                                <b><i className="fa fa-user"></i> Operator</b>
                                <p>{request.tractor_operator ? <HistoryLink url={`/operators?filter_id=${request.tractor_operator.id}&q=${request.tractor_operator.name}`} onClick={this.toggle.bind(this)}>{request.tractor_operator.name }</HistoryLink> : "N/A"}</p>
                            </div>
                            <div className="col-md-4">
                                <b>{HTML.renderIcon("tractor")} Tractor</b>
                                <p>{request.tractor ? <HistoryLink url={`/tractors?filter_id=${request.tractor.id}&q=${request.tractor.name}`} onClick={this.toggle.bind(this)}>{Utils.formatTractorName(request.tractor,false,false)}</HistoryLink> : "N/A"}</p>
                            </div>
                        </div>

                        <div style={{ backgroundColor:"#f3f3f3" , padding: 5 }}>
                            <b>Assigned By: </b>  {request.binder ? request.binder.name : <Badge>Unknown</Badge>}
                        </div>

                    </div>
                </div>);
        }

        return postContent;
    }

    initMap(map){
        this._mapView = map;
    }

    setTrackCoordCenter(){

        //  Keep the map's center as the marker's position
        const center = this._mapView.getCenter();

        const coord = {
            lat: center.lat(),
            lng: center.lng()
        };

        this.setState({
            trackCoord: coord
        });

    }

    render(){

        const me = this;
        const state = this.state;
        const request = state.request;
        const google = window.google;

        //
        const markers = [];

        switch (state.assignmentMode){
            case AssignmentMode.PinLocation:{

                markers.push({
                    title: "",
                    location:state.trackCoord
                });

            }break;
            case AssignmentMode.None:{

                if(request) {

                    let mkTarget;
                    if(state.locationOverride){

                        const loc = state.locationOverride;

                        mkTarget = {
                            title: loc.location,
                            location: loc
                        };

                    }
                    else if(state.selectedPlace){

                        let lat = state.selectedPlace.geometry.location.lat();
                        let lng = state.selectedPlace.geometry.location.lng();

                        markers.push({
                            title: state.selectedPlace.formatted_address,
                            location: { lat: lat  , lng: lng}
                        });

                    }
                    else{

                        if(request.location_lat && request.location_long) {

                            mkTarget = {
                                title: request.location,
                                location: {lat: Number(request.location_lat), lng: Number(request.location_long)}
                            };
                        }
                    }

                    if(mkTarget)
                        markers.push(mkTarget);

                }

            }break;
        }

        return <LoadingOverlay active={this.state.overlayActive} text={this.state.overlayMessage} spinner>

            <EventListener events={['handle_tractor_request']}
                           onEvent={this.onEventHandler.bind(this)}/>

               <LocationListener onChange={() => this.setState({
                   isOpen: false
               })}/>

            <Modal className={"modal-lg fullscreen-modal-dialog"}
                   contentClassName="fullscreen-modal-content-w100"
                   isOpen={this.state.isOpen}>

                <ModalHeader toggle={this.toggle}>Request Details</ModalHeader>

                <ModalBody>

                    {request && <div className="row" style={{ marginBottom: 50 }}>

                        <div className="col-md-3">
                            <b>Request Id</b>
                            <p>{request.order_id}</p>

                            <b>Service</b>
                            <p style={Styles.label}>{request.service ? request.service.name  : ''}</p>

                            <b>Quantity</b>
                            <p style={Styles.label}><NumberLabel value={request.hectares}/> {request.service.unit_name.toLowerCase()}{request.hectares > 1 ? 's' : ''}</p>

                            <b>Cost</b>
                            <p style={Styles.label}><CurrencyLabel value={request.cost}/></p>

                            <b>Location</b>
                            <p className="btn-link" style={{ cursor: "pointer" }} title="Click to change location directly from map" onClick={() => {

                                //  Set selecting state
                                this.setState({
                                    isSelecting: true
                                });

                            }}>{request.location}</p>

                            <b>Status</b>
                            {StatusRender(request)}

                            <b>Payment Status</b>
                            {HtmlHelpers.renderTransactionStatus(request,() => {
                                this._txnCycleDlg.show(request.transactions,request);
                            })}

                            <b>Time Sent</b>
                            <TimeAgo id="time_sent" date={request.date_created}/>

                        </div>
                        <div className="col-md-3">

                            <b>Name</b>
                            <p style={Styles.label}>{request.name}</p>


                            <b>Phone</b>
                            <p style={Styles.label}>{request.phone}</p>


                            {request.fbo && <div style={{marginTop: 2}}>
                                <b style={{display: "block"}}>Requested By</b>
                                <p>
                                    <HistoryLink url={`/fbo?filter_id=${request.fbo_id}&q=${request.fbo.name}`} onClick={this.toggle.bind(this)}>(<span className="btn-link">FBO</span>) {request.fbo.name}</HistoryLink>
                                </p>
                            </div>}

                            {request.farmer && <div style={{marginTop: 2}}>
                                <b style={{display: "block"}}>Farmer</b>
                                <p>
                                    <HistoryLink url={`/farmers?filter_id=${request.farmer_id}&q=${request.farmer.name}`} onClick={this.toggle.bind(this)}>(<span className="btn-link">{request.fbo ? "On Behalf" : "Sent By"}</span>) {request.farmer.name}</HistoryLink>
                                </p>
                            </div>}


                            <div><b>Rating</b></div>
                            <p>{request.operator_rating ?  <ReactRating readonly
                                                                        emptySymbol="fa fa-star-o"
                                                                        fullSymbol="fa fa-star"
                                                                        fractions={2}
                                                                        initialRating={request.operator_rating}/> :
                                <span>NOT RATED</span>}</p>



                            <b><i className="fa fa-calendar"/> Start Time</b>
                            {(request.date_started || (request.status === RequestStatus.Completed && request.date_assigned))  ?

                                <React.Fragment>
                                    <TimeAgo showRawDate
                                             dateFormat="L"
                                             id="date_started"
                                             date={request.date_started || request.date_assigned}/>
                                    <br/>
                                </React.Fragment>
                                :
                                <p>NOT STARTED</p>}

                            {request.is_booking  && <React.Fragment>

                                <b><i className="fa fa-calendar"/> Booking Date</b>
                                <TimeAgo showRawDate
                                         dateFormat="L"
                                         id="booking_date"
                                         date={request.deadline_time}/>
                                <br/>

                            </React.Fragment>}


                            {request.price_binding && <React.Fragment>

                                <b>Fuel Option</b>
                                <p style={Styles.label}>{request.price_binding.pricing_group.name}</p>

                            </React.Fragment>}

                            {request.price_binding && request.price_binding.product !== DefaultBindingProduct && <React.Fragment>
                                <b>Crop/Product</b>
                                <p style={Styles.label}>{request.price_binding.product}</p>
                            </React.Fragment>}

                            {request.metadata && request.metadata.custom_product_name &&  <React.Fragment>
                                <b>Crop/Product</b>
                                <p style={Styles.label}>{request.metadata.custom_product_name}</p>
                            </React.Fragment>}

                            <React.Fragment>
                                <b><i className="fa fa-money"/> Total Payouts</b>
                                <p style={Styles.label}><CurrencyLabel currency={request.txn_currency} value={_.sumBy(request.payments_issued.filter(x => x.status === RequestPaymentStatus.Success),x => x.amount)}/></p>
                            </React.Fragment>

                        </div>

                        <div className="col-md-6" style={ !google ? { backgroundColor: "#efefef" } : null }>

                            <div id="map-frame" style={{width: '100%' , height:  !google ? null : 420}} >

                                {google ? <LoadMap
                                        onMapLoad={(map) => this.initMap(map)}
                                        onMapClick={(evt) => {

                                            const latLng = evt.latLng;
                                            const lat = latLng.lat();
                                            const lng = latLng.lng();

                                            //
                                            me.setState({
                                                trackCoord:{
                                                    lat: lat,
                                                    lng: lng
                                                }
                                            });

                                        }}
                                        defaultZoom={this.state.mapDefaultZoom}
                                        onDoubleClick={(evt) => {

                                            if(request.status !== RequestStatus.Unassigned){
                                                return;
                                            }

                                            if(this.state.assignmentMode != AssignmentMode.PinLocation){

                                                const latLng = evt.latLng;
                                                const lat = latLng.lat();
                                                const lng = latLng.lng();

                                                this.setState({
                                                    assignmentMode: AssignmentMode.PinLocation,
                                                    trackCoord: {
                                                        lat: lat,
                                                        lng: lng
                                                    }
                                                })
                                            }

                                        }}
                                        defaultOptions={{
                                            fullscreenControl: false
                                        }}
                                        loadingElement={
                                            <div style={{ height: 420 }}>
                                                <Spinner name="line-spin-fade-loader" style={{'text-align':'center'}}/>
                                            </div>
                                        }
                                        containerElement={<div style={{ height: 420 , minHeight: 220 }} />}
                                        mapElement={<div style={{ height: 420 }} />}
                                        center={{lat: request.location_lat, lng: request.location_long }}
                                        markers={markers} /> :
                                    <div className="text-center" style={{
                                        marginTop: '35%',
                                        maxWidth: 192,
                                        marginLeft: 'auto',
                                        marginRight: 'auto'
                                    }}>

                                        <i className="fa fa-times fa-5x"></i>
                                        <p>Failed to load maps. Ensure your network connection <i className="fa fa-globe"></i> is active and try again!</p>

                                    </div>}

                            </div>

                            { (google && request.status == RequestStatus.Unassigned ) && <div className="clearfix">

                                <div className="pull-left">

                                    <ButtonGroup>

                                        <Button size={"sm"} color={"primary"} outline={true} active={state.assignmentMode == AssignmentMode.PinLocation} onClick={() => {

                                            let mode;
                                            switch (state.assignmentMode){
                                                case AssignmentMode.PinLocation:
                                                    mode = AssignmentMode.None;
                                                    break;
                                                case AssignmentMode.None:
                                                    mode = AssignmentMode.PinLocation;
                                                    this.setTrackCoordCenter();
                                                    break;
                                            }

                                            this.setState({
                                                assignmentMode: mode
                                            });

                                        }}><i className="fa fa-mouse-pointer"></i> Select Location</Button>

                                        <Button size={"sm"} color={"primary"} outline={true} onClick={() => {

                                            //  show dialog for selecting location
                                            this._locationGuessDlg.show();

                                        }}><i className="fa fa-connectdevelop"></i> Guess Location</Button>

                                    </ButtonGroup>

                                </div>


                                <div className="pull-right">

                                    {state.assignmentMode == AssignmentMode.PinLocation && <ButtonGroup>
                                        <Button size={"sm"} color={"danger"} outline={true} onClick={() =>{

                                            this.setState({
                                                assignmentMode: AssignmentMode.None
                                            });

                                        }}><i className="fa fa-stop"></i> Cancel</Button>

                                        <Button size={"sm"} color={"success"} outline={false} onClick={() => {

                                            //  apply the assignment mode
                                            this.onApplyCurrentLocation(this.state.trackCoord);


                                        }}><i className="fa fa-check"></i> Apply</Button>
                                    </ButtonGroup>}

                                </div>

                            </div>}

                        </div>
                    </div>}

                    {request && this.renderPostContent()}

                </ModalBody>

                {request && this.renderFooter()}

                <TransactionCycleDialog ref={r => this._txnCycleDlg = r } onTransactionUpdate={async () => {

                    this.toggleOverlay('Preparing view, please hold on...');

                    const request = await this.queryRequest(this.state.request.id);
                    if(request){

                        this.setState({
                            request
                        });

                    }

                    this.toggleOverlay(null);

                }}/>

                <StatusCycleDialog ref={r => this._statusCycleDlg = r}/>

                <SuggestionDetailDialog ref={r => this._suggestionDetailDlg = r }/>

            </Modal>
        </LoadingOverlay>;
    }

    onApplyCurrentLocation(coord){

        this.geoCode.geocode({ location : coord },(results,status) =>{

            if(status === "OK"){

                this.setState({
                    reverseGeoCodeResults: results
                });

                //
                this._locationPicker.show();
            }
            else{
                alert("Failed resolving address for selected location!");
            }

        })

    }

}

TractorRequestHandler.propTypes = {
    mapDefaultZoom: PropTypes.number,
    onRequestComplete: PropTypes.func,
    onRequestAssigned: PropTypes.func,
    onLocationChanged: PropTypes.func,
    onRequestDeleted: PropTypes.func,
    onRequestReleased: PropTypes.func
};

TractorRequestHandler.defaultProps = {
    mapDefaultZoom: 7
};


export default TractorRequestHandler;



// WEBPACK FOOTER //
// ./src/components/TractorRequestHandler/TractorRequestHandler.js